import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("afc_admin_token", data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      setError("Invalid credentials");
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-100 shadow-[0_30px_80px_-30px_rgba(30,95,217,0.35)] p-8 lg:p-10">
        <div className="flex flex-col items-center">
          <Logo className="h-16" />
          <div className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#1E5FD9] font-semibold">
            <ShieldCheck className="w-4 h-4" /> Admin Access
          </div>
          <h1 className="mt-3 font-display text-2xl font-semibold text-[#0B132B]">Sign in</h1>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <Label>Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="mt-1" data-testid="admin-email" />
          </div>
          <div>
            <Label>Password</Label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="mt-1" data-testid="admin-password" />
          </div>
          {error && (
            <p className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2" data-testid="admin-login-error" role="alert">
              {error}
            </p>
          )}
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#1E5FD9] hover:bg-[#174AB0] py-6" data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
